/**
 * CHAT HISTORY HOOK
 * Manages chat message history and persistence
 */

import { useState, useCallback } from 'react';

interface Message {
  id: string;
  type: 'user' | 'ai' | 'system';
  content: string;
  timestamp: number;
  codeBlocks?: Array<{
    language: string;
    code: string;
  }>;
  suggestions?: string[];
  processingTime?: number;
}

export function useChatHistory(sessionId: string) {
  const [messages, setMessages] = useState<Message[]>([]);

  const addMessage = useCallback((message: Message) => {
    setMessages(prev => [...prev, message]);
  }, []);

  const clearHistory = useCallback(() => {
    setMessages([]);
  }, []);

  const updateMessage = useCallback((id: string, updates: Partial<Message>) => {
    setMessages(prev => 
      prev.map(msg => 
        msg.id === id ? { ...msg, ...updates } : msg
      )
    );
  }, []);

  return {
    messages,
    addMessage,
    clearHistory,
    updateMessage,
  };
}